/// <reference types="@welldone-software/why-did-you-render" />
import React from "react";

if (import.meta.env.VITE_TARGET_ENV === "DEV") {
  console.log(`Tracking updates`);
  const whyDidYouRender = (await import("@welldone-software/why-did-you-render")).default;
  whyDidYouRender(React, {
    trackAllPureComponents: true,
  });
}
